import { render, staticRenderFns } from "./sub-header-content.vue?vue&type=template&id=3081c1c6&scoped=true"
import script from "./sub-header-content.vue?vue&type=script&lang=js"
export * from "./sub-header-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3081c1c6",
  null
  
)

export default component.exports